import { type ReactElement, type ReactNode } from "react";
import { PostHogProvider } from 'posthog-js/react'
import { initPostHogClient } from "../model/services/initPostHogClient";

export function AnalyticsProvider({ children }: { children: ReactNode}): ReactElement {
  const isDisabled = window.location.href.includes("127.0.0.1") || window.location.href.includes("localhost")

  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (isDisabled) return <>{children}</>

  const instance = initPostHogClient()

  return <PostHogProvider client={instance}>{children}</PostHogProvider>
}
